module.exports = __webpack_public_path__ + "static/media/noti.a29c4825.svg";